"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _accident = require("./accident");
Object.keys(_accident).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _accident[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _accident[key];
    }
  });
});
var _advertising = require("./advertising");
Object.keys(_advertising).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _advertising[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _advertising[key];
    }
  });
});
var _barrier = require("./barrier");
Object.keys(_barrier).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _barrier[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _barrier[key];
    }
  });
});
var _blindSpot = require("./blind-spot");
Object.keys(_blindSpot).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _blindSpot[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _blindSpot[key];
    }
  });
});
var _brokenGlass = require("./broken-glass");
Object.keys(_brokenGlass).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _brokenGlass[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _brokenGlass[key];
    }
  });
});
var _dustbin = require("./dustbin");
Object.keys(_dustbin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dustbin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dustbin[key];
    }
  });
});
var _badWeather = require("./bad-weather");
Object.keys(_badWeather).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _badWeather[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _badWeather[key];
    }
  });
});
var _bicycleDammage = require("./bicycle-dammage");
Object.keys(_bicycleDammage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bicycleDammage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bicycleDammage[key];
    }
  });
});
var _bicycleFacilityRequest = require("./bicycle-facility-request");
Object.keys(_bicycleFacilityRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bicycleFacilityRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bicycleFacilityRequest[key];
    }
  });
});
var _bicycleParkingRequest = require("./bicycle-parking-request");
Object.keys(_bicycleParkingRequest).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _bicycleParkingRequest[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _bicycleParkingRequest[key];
    }
  });
});
var _blockedRoad = require("./blocked-road");
Object.keys(_blockedRoad).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _blockedRoad[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _blockedRoad[key];
    }
  });
});
var _cartographicIssue = require("./cartographic-issue");
Object.keys(_cartographicIssue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _cartographicIssue[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _cartographicIssue[key];
    }
  });
});
var _danger = require("./danger");
Object.keys(_danger).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _danger[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _danger[key];
    }
  });
});
var _dangerousCrossing = require("./dangerous-crossing");
Object.keys(_dangerousCrossing).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dangerousCrossing[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dangerousCrossing[key];
    }
  });
});
var _dangerousExit = require("./dangerous-exit");
Object.keys(_dangerousExit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dangerousExit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dangerousExit[key];
    }
  });
});
var _dangerousRoad = require("./dangerous-road");
Object.keys(_dangerousRoad).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dangerousRoad[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dangerousRoad[key];
    }
  });
});
var _deadLeaves = require("./dead-leaves");
Object.keys(_deadLeaves).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deadLeaves[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deadLeaves[key];
    }
  });
});
var _faultyFacilities = require("./faulty-facilities");
Object.keys(_faultyFacilities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _faultyFacilities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _faultyFacilities[key];
    }
  });
});
var _flood = require("./flood");
Object.keys(_flood).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _flood[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _flood[key];
    }
  });
});
var _freezingRain = require("./freezing-rain");
Object.keys(_freezingRain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _freezingRain[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _freezingRain[key];
    }
  });
});
var _gcum = require("./gcum");
Object.keys(_gcum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _gcum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _gcum[key];
    }
  });
});
var _heavyCarTraffic = require("./heavy-car-traffic");
Object.keys(_heavyCarTraffic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _heavyCarTraffic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _heavyCarTraffic[key];
    }
  });
});
var _heavyPedestrianTraffic = require("./heavy-pedestrian-traffic");
Object.keys(_heavyPedestrianTraffic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _heavyPedestrianTraffic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _heavyPedestrianTraffic[key];
    }
  });
});
var _incivilities = require("./incivilities");
Object.keys(_incivilities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _incivilities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _incivilities[key];
    }
  });
});
var _kerb = require("./kerb");
Object.keys(_kerb).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _kerb[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _kerb[key];
    }
  });
});
var _mapError = require("./map-error");
Object.keys(_mapError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _mapError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _mapError[key];
    }
  });
});
var _markingErased = require("./marking-erased");
Object.keys(_markingErased).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _markingErased[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _markingErased[key];
    }
  });
});
var _missingFacility = require("./missing-facility");
Object.keys(_missingFacility).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _missingFacility[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _missingFacility[key];
    }
  });
});
var _missingParking = require("./missing-parking");
Object.keys(_missingParking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _missingParking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _missingParking[key];
    }
  });
});
var _missingPoi = require("./missing-poi");
Object.keys(_missingPoi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _missingPoi[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _missingPoi[key];
    }
  });
});
var _needMaintenance = require("./need-maintenance");
Object.keys(_needMaintenance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _needMaintenance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _needMaintenance[key];
    }
  });
});
var _noLighting = require("./no-lighting");
Object.keys(_noLighting).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _noLighting[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _noLighting[key];
    }
  });
});
var _noMarking = require("./no-marking");
Object.keys(_noMarking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _noMarking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _noMarking[key];
    }
  });
});
var _obstacles = require("./obstacles");
Object.keys(_obstacles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _obstacles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _obstacles[key];
    }
  });
});
var _other = require("./other");
Object.keys(_other).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _other[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _other[key];
    }
  });
});
var _parkingNearCycleway = require("./parking-near-cycleway");
Object.keys(_parkingNearCycleway).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parkingNearCycleway[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parkingNearCycleway[key];
    }
  });
});
var _pebbles = require("./pebbles");
Object.keys(_pebbles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pebbles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pebbles[key];
    }
  });
});
var _pole = require("./pole");
Object.keys(_pole).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pole[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pole[key];
    }
  });
});
var _policePresence = require("./police-presence");
Object.keys(_policePresence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _policePresence[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _policePresence[key];
    }
  });
});
var _poorQualityRoad = require("./poor-quality-road");
Object.keys(_poorQualityRoad).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _poorQualityRoad[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _poorQualityRoad[key];
    }
  });
});
var _pothole = require("./pothole");
Object.keys(_pothole).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pothole[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pothole[key];
    }
  });
});
var _roadworks = require("./roadworks");
Object.keys(_roadworks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _roadworks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _roadworks[key];
    }
  });
});
var _roots = require("./roots");
Object.keys(_roots).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _roots[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _roots[key];
    }
  });
});
var _suggestions = require("./suggestions");
Object.keys(_suggestions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _suggestions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _suggestions[key];
    }
  });
});
var _snow = require("./snow");
Object.keys(_snow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _snow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _snow[key];
    }
  });
});
var _supportLocalAuthorities = require("./support-local-authorities");
Object.keys(_supportLocalAuthorities).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _supportLocalAuthorities[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _supportLocalAuthorities[key];
    }
  });
});
var _theft = require("./theft");
Object.keys(_theft).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _theft[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _theft[key];
    }
  });
});
var _traffic = require("./traffic");
Object.keys(_traffic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _traffic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _traffic[key];
    }
  });
});
var _trafficConditions = require("./traffic-conditions");
Object.keys(_trafficConditions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _trafficConditions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _trafficConditions[key];
    }
  });
});
var _tree = require("./tree");
Object.keys(_tree).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _tree[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _tree[key];
    }
  });
});
var _vegetation = require("./vegetation");
Object.keys(_vegetation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _vegetation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _vegetation[key];
    }
  });
});